import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import MediaPickerModal from "../components/MediaPickerModal";
import { useNavigate, useParams } from "react-router-dom";
import { getUserDetails, updateUser } from "../action/user";
import { roleList } from "../action/role";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import eye from "../assets/eye.svg";
import eyeOff from "../assets/eye-off.svg";

const EditAccount = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showMediaPicker, setShowMediaPicker] = useState(false);
  const [banner, setBanner] = useState("");
  const [user, setUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const fetchRoles = async () => {
    try {
      const res = await roleList(1, 100);
      if (res?.status) {
        setRoles(res.data.list);
      }
    } catch (error) {
      console.log("Error");
    }
  };
  const fetchDetail = async () => {
    try {
      const res = await getUserDetails(id);
      if (res?.status) {
        setUser(res?.data);
        if (res?.data?.pic) {
          setBanner(res.data.pic);
        }
      }
    } catch (error) {
      console.log("User Detail Not found");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: user?.name || "",
      email: user?.email || "",
      role_id: user?.role_id || "",
      organization_id: user?.organization_id || "",
      project_id: user?.project_id || "",
      password: "",
      desc: user?.desc || "",
      pic: user?.pic || "",
      extras: {
        profession: user?.extras?.profession || "",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),

      email: Yup.string()
        .required("Email is required")
        .matches(
          /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
          "Enter a valid email address"
        ),

      role_id: Yup.string().required("Role is required"),
      password: Yup.string()
        .matches(
          /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,20})?$/,
          "Password must be 8-20 characters and include upper, lower, number, special"
        ),
    }),
    onSubmit: async (values) => {
      const payload = { ...values };
      if (!payload.password) {
        delete payload.password;
      }
      if (roles.find(r => r._id === payload.role_id)?.name?.toLowerCase() !== "author") {
        delete payload.desc;
        delete payload.extras;
      }
      delete payload.organization_id;
      delete payload.project_id;
      const res = await updateUser(id, payload);
      if (res?.status) {
        toast.success(res.message);
        navigate("/account");
      } else {
        toast.error(res.message);
      }
    },
  });

  useEffect(() => {
    fetchRoles();
    fetchDetail();
  }, []);
  return (
    <>
      <PageHeader pageTitle="Edit User" is_deploy_enable={false}>
        <button
          className="btn-white me-3"
          onClick={() => navigate("/account")}
        >
          Discard
        </button>
        <button
          type="button"
          className="btn-black"
          onClick={formik.handleSubmit}
        >
          Update User
        </button>
      </PageHeader>

      <div className="page-container">
        <div className="row">
          <div className="col-lg-12">
            <form onSubmit={formik.handleSubmit}>
              <div className="theme-card p-4 mb-4">
                <div className="card-title pb-3">General Information</div>
                <div className="row">
                  <div className="col-12 mb-4">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">Profile Picture</label>
                      <div className="d-flex align-items-center gap-4 mt-2">
                        <div
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            cursor: "pointer",
                            border: "3px solid #EEEFF2",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
                            position: "relative",
                            backgroundColor: "#f8f9fa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={() => setShowMediaPicker(true)}
                        >
                          {banner ? (
                            <img
                              src={banner}
                              alt="preview"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <span style={{ fontSize: "32px", color: "#aaa" }}>👤</span>
                          )}
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn-white btn-sm"
                            onClick={() => setShowMediaPicker(true)}
                          >
                            Choose Photo
                          </button>
                          {banner && (
                            <button
                              type="button"
                              className="btn-link1 text-danger ms-3"
                              style={{ fontSize: "14px", border: "none", background: "none" }}
                              onClick={() => {
                                setBanner("");
                                formik.setFieldValue("pic", "");
                              }}
                            >
                              Remove
                            </button>
                          )}
                          <div className="text-muted mt-1" style={{ fontSize: "12px" }}>
                            JPG, PNG or GIF. Recommended size: 400x400px.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="frm-input"
                        placeholder="Enter name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className="text-danger">{formik.errors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="frm-input"
                        placeholder="Enter email"
                        autoComplete="off"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">Password</label>
                      <div className="input-with-icon right">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="frm-input"
                          placeholder="Enter password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <span
                          role="button"
                          className="password-eye-btn"
                          onClick={() => setShowPassword((s) => !s)}
                          aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                          <img src={showPassword ? eye : eyeOff} alt="" className="password-eye" />
                        </span>
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="text-danger">{formik.errors.password}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="frm-group">
                      <label className="frm-label d-flex align-items-center">
                        Role
                      </label>
                      <select
                        name="role_id"
                        className="frm-select"
                        value={formik.values.role_id}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value="">Select Role</option>
                        {roles.map((role) => (
                          <option key={role._id} value={role._id}>
                            {role.name}
                          </option>
                        ))}
                      </select>
                      {formik.touched.role_id && formik.errors.role_id && (
                        <div className="text-danger">{formik.errors.role_id}</div>
                      )}
                    </div>
                  </div>

                  {roles.find(r => r._id === formik.values.role_id)?.name?.toLowerCase() === "author" && (
                    <>
                      <div className="col-12">
                        <div className="frm-group">
                          <label className="frm-label d-flex align-items-center">Description</label>
                          <textarea
                            name="desc"
                            className="frm-input"
                            rows="4"
                            placeholder="Enter description/bio for the author"
                            value={formik.values.desc}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="frm-group">
                          <label className="frm-label d-flex align-items-center">Profession</label>
                          <input
                            type="text"
                            name="extras.profession"
                            className="frm-input"
                            placeholder="Enter profession (e.g. QA, Writer)"
                            value={formik.values.extras?.profession || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                      </div>
                    </>
                  )}

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <MediaPickerModal
        show={showMediaPicker}
        onClose={() => setShowMediaPicker(false)}
        onSelect={(mediaUrl) => {
          setBanner(mediaUrl);
          formik.setFieldValue("pic", mediaUrl);
          setShowMediaPicker(false);
        }}
      />
    </>
  );
};

export default EditAccount;
